import React from "react";

const Navbar = () => {
  return (
    <nav className="navbar">
      <div className="navbar-container">
      <div className="logo-container">
        <h1 className="logo">FlowRead</h1>
          <img src="/assets/ic_launcher1.png" alt="FlowRead Logo" className="product-icon-nav" />
          
        </div>
        
        <ul className="nav-links">
        <li><a href="#overview">Overview</a></li>
  <li><a href="#features">Features</a></li>
  <li><a href="#updates">Upcoming Updates</a></li>
  <li><a href="#contact">Contact Us</a></li>
  <li><a href="#privacy">Privacy Policy</a></li>
        </ul>
      </div>
    </nav>
  );
};

export default Navbar;
